// src/constants/colors.js
export const COLORS = {
  primary: '#B57EDC',        // your lavender
  primaryLight: '#F3E8FF',   // very pale lavender
  textGray: '#666666',
  lightBackground: 'rgb(245, 245, 245)',
  // …you can put more (secondary, accent, etc.)
}
